import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { UserContextProvider } from './context/UserContext';
import { CartContextProvider } from './context/CartContext';
import { SessionContextProvider } from './context/SessionContext';

const root = ReactDOM.createRoot(document.getElementById('core'));

window.addEventListener("load", () => {
  const loader = document.getElementById("preloader");
  if (loader) {
    loader.classList.add("fade-out");
    setTimeout(() => loader.remove(), 300);
  }
});

root.render(
  <BrowserRouter>
    <UserContextProvider>
      <CartContextProvider>
        <SessionContextProvider>
          <App />
        </SessionContextProvider>
      </CartContextProvider>
    </UserContextProvider>
  </BrowserRouter>
);
